import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";

import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class DcoCreativesService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_DCO_URL}/creative/`;

  getCreativePreview(params: any = {}, data: any) {
    let url = this.buildUrl(`${this.resource_url}preview/`, '', params);
    return this.post(url, data);
  }
}
